import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./AddNewGoalPop.module.scss";
import { useGetDisciplineAreasQuery, useGetGoalContextsQuery, useGetGoalsQuery } from "store/services/utility";
import { Formik } from "formik";
import goalFormSchema from "./Goal.schema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { cloneDeep } from "lodash";
import LoadingButton from "components/shared/LoadingButton";
import { successMessageToast } from "helpers/common";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import { GOAL_DESC_WORD_LIMIT } from "config/constants";
import close from "Assets/images/cross_icon.png"
import { useCreateGoalMutation, useUpdateGoalMutation } from "store/services/clients/reports-v2/treatmentPlanGoals";
// img

const AddAssessmentGoalPop = ({ showPopup, closePopup, assessmentId, disciplineId, data, submitCallback, clientType }) => {
  const editMode = !!data;
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedGoal, setSelectedGoal] = useState(null);

  const { data: disciplineAreas, isFetching: areasLoading } = useGetDisciplineAreasQuery(disciplineId, { skip: !disciplineId });
  const { data: disciplineAreaGoals, isFetching: goalsLoading } = useGetGoalsQuery({ disciplineId, areaId: selectedArea }, { skip: !disciplineId || !selectedArea });
  // const { data: goalContexts, isFetching: contextsLoading } = useGetGoalContextsQuery({ goalId: selectedGoal }, { skip: !selectedGoal });
  const [submitCreateGoal, { isLoading }] = useCreateGoalMutation();
  const [submitUpdateGoal, { isLoading: updateLoading }] = useUpdateGoalMutation();

  const disciplineAreaOptions =
    disciplineAreas?.length > 0
      ? disciplineAreas?.map(area => ({
        value: area.id,
        label: area.name
      }))
      : [];

  const areaGoalsOptions =
    disciplineAreaGoals?.length > 0
      ? disciplineAreaGoals?.map(goal => ({
        value: goal.id,
        label: goal.title
      }))
      : [];

  const initialValues = useMemo(() => {
    let output = {
      discipline_id: disciplineId || null,
      area_id: null,
      goal_id: null,
      goal_details: "",
    }

    if (!data) return output

    output = {
      ...output,
      area_id: data?.area_id,
      goal_id: data?.goal_id,
      goal_details: data?.goal_details || "",
      // goal_notes: data?.goal_notes || "",
    }

    return output;
  }, [data, disciplineId]);

  useEffect(() => {
    if (!data) {
      return;
    }

    setSelectedArea(data?.area_id?.value);
    setSelectedGoal(data?.goal_id?.value);
  }, [data]);

  const handleSubmit = async (values) => {
    try {
      // format payload
      let payload = cloneDeep(values);
      payload.area_id = payload.area_id?.value;
      payload.goal_id = payload.goal_id?.value;

      let response = null;
      if (editMode) {
        response = await submitUpdateGoal({
          goalId: data?.id,
          data: payload,
          clientType,
          method: "PUT"
        }).unwrap();
      } else {
        response = await submitCreateGoal({
          assessmentId,
          data: payload,
          clientType
        }).unwrap();
      }

      if (response?.data) {
        successMessageToast(response?.data?.message)
        closePopup();
        if (typeof submitCallback === "function") submitCallback(response);
      }
    } catch (err) {
      console.error("Error creating goal", err);
    }
  }

  return (
    <Modal
      show={showPopup}
      className={`${styles.AddNewGoalPop} modal-v2  AddNewGoalPop`}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      {/* <Modal.Header closeButton>
          <h6 className="m-0 fw-bold text-dark">{editMode ? "Edit AN AREA" : "ADD AN AREA"}</h6>
        </Modal.Header> */}
      <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
        <Formik
          initialValues={initialValues}
          validationSchema={goalFormSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleSubmit,
            setFieldValue,
            errors,
            values
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="reports-v2">
                <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                  <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit AN AREA" : "ADD AN AREA"}</h6>
                  <img onClick={closePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                </div>
                <Col md="9" className="mb-1">
                  <label className="discharge-screen-label mt-0" style={{ whiteSpace: "nowrap", marginTop: "11px" }}>Select Area</label>
                  <AppSelect2Field
                    name="area_id"
                    placeholder="Choose an Area"
                    classNamePrefix={"khan"}
                    option={disciplineAreaOptions}
                    isLoading={areasLoading}
                    onChange={(selected) => {
                      setSelectedArea(selected?.value);
                      setFieldValue("goal_id", null);
                    }}
                  />
                </Col>
                <Col md="9" className="my-1">
                  <label className="discharge-screen-label" style={{ whiteSpace: "nowrap", marginTop: "11px" }}>Select Goal</label>
                  <AppSelect2Field
                    name="goal_id"
                    placeholder="Choose a Goal"
                    classNamePrefix={"khan"}
                    option={areaGoalsOptions}
                    isLoading={goalsLoading}
                    onChange={(selected) => {
                      setSelectedGoal(selected?.value);
                    }}
                  />
                </Col>
                <Col md="12" className="my-1 text-editror-without-border">
                  <label className="discharge-screen-label" style={{ whiteSpace: "nowrap", marginTop: "11px" }}>Add/edit Detail</label>
                  <AppInputField
                    name="goal_details"
                    fieldType={"textarea"}
                    className={`${styles.formControl} form-control rounded-3 bg-white h-auto`}
                    rows={4}
                    placeholder="Add/edit detail"
                  // wordLimit={GOAL_DESC_WORD_LIMIT}
                  />
                </Col>
              </div>
              <div className="btnWrpper mt-2 text-end d-flex justify-content-end">
                <LoadingButton
                  type="submit"
                  className="blue-btn"
                  isLoading={isLoading || updateLoading}
                >
                  {editMode ? "Update Goal" : "Add to Report"}
                </LoadingButton>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddAssessmentGoalPop;
